import { PhotoIcon } from '@heroicons/react/24/outline';

// Fixed/Static categories - no database needed
const staticCategories = [
  {
    id: 1,
    name: 'नेपाली साहित्य',   // Nepali Literature
    englishName: 'Nepali Literature',
    description: 'Classic and modern Nepali literature',
    order: 1,
    isActive: true,
    postCount: 0
  },
  {
    id: 2,
    name: 'लोक संस्कृति',     // Folk Culture
    englishName: 'Folk Culture',
    description: 'Nepali folk culture and traditions',
    order: 2,
    isActive: true,
    postCount: 0
  },
  {
    id: 3,
    name: 'आधुनिक कविता',     // Modern Poetry
    englishName: 'Modern Poetry',
    description: 'Contemporary Nepali poetry',
    order: 3,
    isActive: true,
    postCount: 0
  },
  {
    id: 4,
    name: 'हास्य व्यंग्य',      // Humor/Satire
    englishName: 'Humor & Satire',
    description: 'Nepali humor and satirical works',
    order: 4,
    isActive: true,
    postCount: 0
  }
];

const Categories = () => {
  const categories = staticCategories;

  return (
    <div>
      {/* Header Section */}
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-gray-900">Categories</h1>
      </div>

      {/* Categories Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {categories.length === 0 ? (
          <div className="col-span-full text-center py-12 text-gray-500">
            <PhotoIcon className="h-12 w-12 mx-auto mb-4 text-gray-300" />
            <p className="text-lg">No categories found</p>
          </div>
        ) : (
          categories.map((category) => (
            <div key={category.id} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-200">
              {/* Image Section */}
              <div className="relative h-40 bg-white flex items-center justify-center">
                {category.image ? (
                  <img 
                    src={category.image} 
                    alt={category.name}
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <div className="text-center">
                    <PhotoIcon className="h-12 w-12 mx-auto text-gray-300 mb-3" />
                    <p className="text-sm text-gray-400 font-medium">{category.englishName || 'No Image'}</p>
                  </div>
                )}
                {/* Count Badge */}
                <div className="absolute top-3 right-3 text-white text-sm px-3 py-1 rounded-full font-semibold" style={{ backgroundColor: '#008577' }}>
                  {category.postCount || 0}
                </div>
              </div>
              
              {/* Content Section */}
              <div className="p-5">
                {/* Green separator line */}
                <div className="w-full h-1 mb-4" style={{ backgroundColor: '#008577' }}></div>
                
                {/* Category Name in Nepali */}
                <h3 className="text-xl font-bold text-gray-900 mb-2" style={{ fontFamily: 'Arial, sans-serif' }}>
                  {category.name}
                </h3>
                
                {/* English Name */}
                <p className="text-sm text-blue-500 font-medium">
                  {category.englishName || 'No English name'}
                </p>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Categories; 